import { motion } from "framer-motion";
import {
  BsPlayCircle,
  BsX,
  BsFlower1,
  BsPeopleFill,
  BsStarFill,
  BsAward,
} from "react-icons/bs";
import { useState } from "react";

const stats = [
  {
    name: "Natural Ingredients",
    value: "100%",
    description: "Pure, natural ingredients in all our products",
    icon: BsFlower1,
  },
  {
    name: "Happy Customers",
    value: "10K+",
    description: "Satisfied customers worldwide",
    icon: BsPeopleFill,
  },
  {
    name: "Product Range",
    value: "25+",
    description: "Unique hair care solutions",
    icon: BsStarFill,
  },
  {
    name: "Years of Excellence",
    value: "3+",
    description: "Delivering quality since 2020",
    icon: BsAward,
  },
];

// const team = [
//   {
//     name: "Sarah Johnson",
//     role: "Founder & CEO",
//     image:
//       "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
//     bio: "With over 15 years in natural hair care, Sarah founded Acquwaa Naturals with a vision to revolutionize the industry.",
//   },
//   {
//     name: "David Chen",
//     role: "Head of Product Development",
//     image:
//       "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
//     bio: "Leading our research team, David ensures every product meets the highest standards of quality and effectiveness.",
//   },
//   {
//     name: "Michelle Addo",
//     role: "Lead Hair Care Specialist",
//     image:
//       "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
//     bio: "Michelle brings her expertise in natural hair care to develop personalized solutions for our customers.",
//   },
// ];

export default function About() {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="bg-gray-50 pt-24">
      {/* Hero Section */}
      <div className="relative h-[70vh] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://res.cloudinary.com/dmxzxo1fk/image/upload/v1741946157/IMG_9603_q20ujf.jpg"
            alt="Natural Hair Care"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40" />
        </div>
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl"
          >
            <div className="w-20 h-1 bg-[#DB5461] rounded-full mb-8" />
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-6 text-white leading-tight">
              Who We <span className="text-[#DB5461]">Are</span>
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed border-l-4 border-[#DB5461] pl-6">
              Empowering natural hair journeys with premium care products and
              expert guidance since 2020.
            </p>
          </motion.div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-gray-50 to-transparent" />
      </div>

      {/* Mission Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h2 className="text-3xl font-serif font-bold text-gray-900">
              Our Mission
            </h2>
            <p className="text-gray-600 text-lg">
              At Acquwaa Naturals, we believe in the power of natural
              ingredients and their ability to transform hair care. Our mission
              is to provide premium, effective products that celebrate and
              enhance the beauty of natural hair.
            </p>
            <p className="text-gray-600 text-lg">
              We're committed to sustainability, using eco-friendly packaging
              and responsibly sourced ingredients. Every product is crafted with
              care, backed by research, and tested to ensure the highest
              quality.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16"
          >
            {stats.map((stat) => (
              <motion.div
                key={stat.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="flex items-start space-x-4">
                  <div className="p-3 bg-[#DB5461]/10 rounded-lg">
                    <stat.icon className="h-6 w-6 text-[#DB5461]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-4xl font-bold text-gray-900 mb-2">
                      {stat.value}
                    </p>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">
                      {stat.name}
                    </h3>
                    <p className="text-gray-500 text-sm">{stat.description}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Manufacturing Process Video Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-serif font-bold text-[#DB5461] mb-4">
              Our Manufacturing Process
            </h2>
            <div className="w-24 h-1 bg-[#DB5461] mx-auto rounded-full mb-6" />
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Take a behind-the-scenes look at how we carefully craft our
              premium hair care products
            </p>
          </motion.div>

          <div className="relative h-[80vh] w-full overflow-hidden rounded-xl shadow-xl">
            <video
              className="absolute inset-0 w-full h-full object-fill bg-black"
              controls
              playsInline
              loop
            >
              <source
                src="https://res.cloudinary.com/dmxzxo1fk/video/upload/v1743595367/Watch_the_Magic_Hands_Pouring_Liquid_Indoors____rl7yep.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8"
          >
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#DB5461]/10 flex items-center justify-center">
                <span className="text-[#DB5461] text-2xl font-bold">1</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Natural Ingredients
              </h3>
              <p className="text-gray-600">
                We carefully source the finest natural ingredients for our
                products
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#DB5461]/10 flex items-center justify-center">
                <span className="text-[#DB5461] text-2xl font-bold">2</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Quality Control
              </h3>
              <p className="text-gray-600">
                Rigorous testing ensures the highest quality standards
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[#DB5461]/10 flex items-center justify-center">
                <span className="text-[#DB5461] text-2xl font-bold">3</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Expert Formulation
              </h3>
              <p className="text-gray-600">
                Our experts craft each formula for optimal results
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Founder and Inspiration Section */}
      <div className="bg-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4">
              Our Story
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              A mother's journey to create the perfect natural hair care
              solution for her daughter
            </p>
          </motion.div>

          {/* Founder Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-24"
          >
            <div className="bg-gradient-to-br from-white to-[#DB5461]/5 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
                <div className="p-8 md:p-12 flex flex-col justify-center">
                  <div className="mb-8">
                    <div className="w-20 h-1 bg-[#DB5461] rounded-full mb-6" />
                    <h3 className="text-3xl font-serif font-bold text-gray-900 mb-3">
                      Naa Shika Asante
                    </h3>
                    <p className="text-[#DB5461] font-medium text-lg italic">
                      Founder
                    </p>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    Driven by maternal love and innovation, Naa founded Acquwaa
                    Naturals when she couldn't find suitable hair care products
                    for her daughter Eva. Her vision has transformed into a
                    premium natural hair care brand that celebrates and nurtures
                    all hair types.
                  </p>
                </div>
                <div className="relative">
                  <div className="absolute inset-0 bg-[#DB5461]/10 backdrop-blur-sm rounded-2xl transform rotate-3 scale-95" />
                  <div className="absolute inset-0 bg-[#DB5461]/5 backdrop-blur-sm rounded-2xl transform -rotate-3 scale-95" />
                  <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500">
                    <img
                      src="https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743593566/nash_g9nxvc.jpg"
                      alt="Naa Shika Asante"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Inspiration Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="bg-gradient-to-bl from-white to-[#DB5461]/5 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
                <div className="relative order-2 md:order-1">
                  <div className="absolute inset-0 bg-[#DB5461]/10 backdrop-blur-sm rounded-2xl transform -rotate-3 scale-95" />
                  <div className="absolute inset-0 bg-[#DB5461]/5 backdrop-blur-sm rounded-2xl transform rotate-3 scale-95" />
                  <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500">
                    <img
                      src="https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743593582/babs-about_ysjcis.jpg"
                      alt="Eva Dione Baaba Acquwaa Amoah"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                  </div>
                </div>
                <div className="p-8 md:p-12 flex flex-col justify-center order-1 md:order-2">
                  <div className="mb-8">
                    <div className="w-20 h-1 bg-[#DB5461] rounded-full mb-6" />
                    <h3 className="text-3xl font-serif font-bold text-gray-900 mb-3">
                      Eva Dione Baaba Acquwaa Amoah
                    </h3>
                    <p className="text-[#DB5461] font-medium text-lg italic">
                      Brand Inspiration
                    </p>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-lg">
                    The inspiration behind Acquwaa Naturals. Eva's natural hair
                    journey as a newborn inspired her mother to create a brand
                    that would provide gentle, effective care for all natural
                    hair types. Her name and her needs became the foundation of
                    what Acquwaa Naturals represents today.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
